import { Component } from '@angular/core';
import { CommonService } from '@increff/commons';
import { Rest } from '../../services';

@Component({
    selector: 'com-logout',
    templateUrl: './logout.html',
    styleUrls: ['./logout.scss'],
})
export class LogoutComponent {
    constructor(
        private urls: Rest,
        private commonService: CommonService) {
        localStorage.removeItem(this.commonService.cipher('lastCheckTime'));
        localStorage.removeItem(this.commonService.cipher('currentUserObj'));
    }

    get loginToHome() {
        return this.urls?.loginUrl;
    }
}
